import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Ավելացրու սա
import { AuthContext } from '../App';
import '../style/Footer.scss';

export default function Footer() {
    const currentYear = new Date().getFullYear();
    const { user } = useContext(AuthContext);
    const navigate = useNavigate(); // Սահմանիր նավիգացիան
    const location = useLocation(); // Սահմանիր լոկացիան

    return (
        <footer className="contact-section">
            <h2>Կապ մեզ հետ</h2>
            <div className="footer-content">
                <div className="contact-info">
                    <p>
                        📍 Հասցե:
                        <a
                            target='_blank'
                            rel="noreferrer"
                            href="https://yandex.com/maps/10262/yerevan/?ll=44.537196%2C40.208060&mode=poi&poi%5Bpoint%5D=44.537776%2C40.208050&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D172876843269&tilt=0.8726646259971648&z=19.53"
                        >
                            Պարույր Սևակ 9
                        </a>
                    </p>
                    <p>📞 Հեռախոս: <a href="tel:+37477053446">+374 77 05 34 46</a></p>
                    <p>📧 Էլ. հասցե: <a href="mailto:ardaeducation2025@gmail.com">ardaeducation2025@gmail.com</a></p>
                </div>

                <div className="social-links">
                    <a href="https://facebook.com" target="_blank" rel="noreferrer">Facebook</a>
                    <a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a>
                    <a href="https://linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a>

                    {/* Dashboard-ի կոճակը */}
                    {user && location.pathname !== '/admin-dashboard' && (
                        <div className="admin-quick-link">
                            <button className="dashboard-btn" onClick={() => navigate('/admin-dashboard')}>
                                ⚙️ Կառավարման վահանակ
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className="footer-bottom">
                <p>© {currentYear} «Arda» կրթական կենտրոն: Բոլոր իրավունքները պաշտպանված են:</p>
            </div>
        </footer>
    );
}